import React, { useState } from 'react';

import SatButton from '@components/common/satUI/SatButton';
import SatInput from '@components/common/satUI/SatInput';
import { toPhone } from '@common/utils/validation';
import { isNil } from '@common/utils';

const CustomerInfoModifySmsSendPopupArea = props => {
  const {
    customerName,
    mobileTelNo,
    custNo,
    sendPlanAgreeSms = () => {},
    setIsSmsSendPopupVisible = () => {},
  } = props;

  const [mobileTelNoState, setMobileTelNoState] = useState(mobileTelNo);

  return (
    <>
      <header className="modal-header">
        <h3 className="layer-tit2">가입 설계 동의 SMS 발송</h3>
      </header>

      <div className="text-center">
        <p className="layer-text mgb-16">
          가입 설계 동의를 받으실
          <br />
          고객님의 휴대전화번호를 입력하세요.
        </p>
      </div>
      <div className="cont">
        <SatInput
          value={customerName}
          label="신청인"
          readOnly
          onChange={() => {}}
          bold
        />

        <SatInput
          value={toPhone(mobileTelNoState)}
          type="number"
          customStyleClass={'mgt-8'}
          label="휴대전화번호"
          onChange={setMobileTelNoState}
          bold
          border
          maxLength={11}
          useMobile
          suffix={() =>
            isNil(mobileTelNoState) ? (
              <></>
            ) : (
              <button
                type="button"
                className="ico ico-del on"
                onClick={() => setMobileTelNoState('')}
              />
            )
          }
        />
      </div>

      <div className="btn-group">
        <SatButton
          styleClass="btn-half cancel"
          label={'취소'}
          onClick={() => setIsSmsSendPopupVisible(false)}
        />
        <SatButton
          styleClass="btn-half confirm"
          label={'발송'}
          onClick={() => {
            if (mobileTelNoState) {
              setIsSmsSendPopupVisible(false);
              sendPlanAgreeSms(custNo, mobileTelNoState);
            }
          }}
        />
      </div>
    </>
  );
};

export default CustomerInfoModifySmsSendPopupArea;
